import React, { useEffect, useState } from 'react';
import styles from '../styles/reminders/RemindersTab.module.css';
import { remindersApi, sortByNextDue } from '../api/remindersApi';
import { useLanguage } from '../contexts/LanguageContext';
import ReminderCalendar from './ReminderCalendar';

export default function RemindersTab() {
  const { t } = useLanguage();
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  async function load() {
    setLoading(true);
    setError(null);
    try {
      const list = await remindersApi.list({ status: 'all', frequency: 'all', q: '' });
      // Auto-remove inactive reminders if setting is enabled
      const autoRemoveInactive = localStorage.getItem('autoRemoveInactiveReminders') === 'true';
      if (autoRemoveInactive) {
        const inactive = list.filter((r) => r && r.active === false);
        if (inactive.length > 0) {
          try {
            await Promise.all(inactive.map((r) => remindersApi.remove(r.id)));
            const refreshed = await remindersApi.list({ status: 'all', frequency: 'all', q: '' });
            setItems(refreshed.sort(sortByNextDue));
          } catch (cleanupErr) {
            setItems(list.sort(sortByNextDue));
            setError(`Fehler beim Entfernen inaktiver Reminders: ${cleanupErr.message || cleanupErr}`);
          }
        } else {
          setItems(list.sort(sortByNextDue));
        }
      } else {
        setItems(list.sort(sortByNextDue));
      }
    } catch (e) {
      setError(e.message || 'Fehler beim Laden');
    } finally {
      setLoading(false);
    }
  }

  useEffect(() => {
    load();
  }, []);

  const handleToggle = async (id, active) => {
    try {
      await remindersApi.toggle(id, active);
      await load();
    } catch (e) {
      setError(e.message);
    }
  };
  const handleDelete = async (id) => {
    try {
      await remindersApi.remove(id);
      await load();
    } catch (e) {
      setError(e.message);
    }
  };

  return (
    <div className={styles.page}>
      {/* Header / Topbar */}
      <header className={styles.topbar} />

      {/* Main Card */}
      <section className={styles.mainCard} aria-label="Kalender">
        <div className={styles.cardHeader}>
          <div className={styles.cardTitleWrap}>
            <h2 className={styles.cardTitle}>{t('reminders.title') || 'Kalender'}</h2>
          </div>
        </div>

        {error && (
          <div className={styles.errorBanner} role="alert">
            {error}
          </div>
        )}

        {loading ? (
          <div className={styles.loadingHint} aria-busy="true" aria-live="polite">
            {t('loading') || 'Lädt...'}
          </div>
        ) : (
          <ReminderCalendar items={items} onToggle={handleToggle} onDelete={handleDelete} onChanged={load} />
        )}
      </section>
    </div>
  );
}
